import { useState } from "react";

import { BsMetaUtil, RoleView } from "@bridgesplit/abf-react";
import { DialogWrapper } from "@bridgesplit/ui";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { AppDialog, useAppDialog } from "app/utils";
import { COPY } from "app/constants";

import { MarketProvider, QuotesProvider } from "./common";
import { UpdateApyAndCollateralCard, MarketLendProvider } from "./lend";
import { MarketDialogWrapper } from "./dialog";
import { DialogHeader } from "../common";

export default function UpdateApyAndCollateralDialog() {
    const { getData } = useAppDialog();
    const data = getData(AppDialog.UpdateStrategyApyAndCollateral);
    const [, setToken] = useState<TokenListMetadata>();

    if (!data?.token || !data?.strategy) return null;
    const principalMint = data?.token?.mint;

    return (
        <MarketProvider
            marketProps={{
                isDialog: true,
                token: data.token,
                selectToken: setToken,
                symbol: BsMetaUtil.getSymbol(data.token),
                loading: false,
                principalMint,
                view: RoleView.Lend
            }}
        >
            <QuotesProvider>
                <MarketLendProvider>
                    <DialogWrapper>
                        <MarketDialogWrapper>
                            <DialogHeader
                                header="Update Position"
                                description={`One of your ${COPY.STRATEGY_TERM.toLowerCase()} settings is missing, please verify the terms and collateral to continue lending`}
                                centerAlign
                            />
                            <UpdateApyAndCollateralCard strategy={data.strategy} />
                        </MarketDialogWrapper>
                    </DialogWrapper>
                </MarketLendProvider>
            </QuotesProvider>
        </MarketProvider>
    );
}
